import * as React from 'react';
import {
  MergeOrder,
  TopModelMergeNameTransformed,
} from '@goldwasserexchange/react-topmodel';
import { errorMessagesTopModelObject } from './topmodels';

export function DefaultInputErrorMessageTopModelsProvider(
  props: React.PropsWithChildren<{ order?: MergeOrder }>,
) {
  const { children, order } = props;
  return (
    <TopModelMergeNameTransformed
      topModels={errorMessagesTopModelObject}
      order={order}
    >
      {children}
    </TopModelMergeNameTransformed>
  );
}
